import { css, html } from 'lit';
import '../elements/d-label.js';
import { customElement, property } from 'lit/decorators.js';
import { LabeledElement } from '../abstracts/labeled-element.js';
import { classMap } from 'lit/directives/class-map.js';
import type { TextWithIcon } from 'src/library/fields/text-with-icons';

/**
 *
 * STATUS OK
 */
@customElement('d-view-text-with-icons')
export class DViewTextWithIcons extends LabeledElement {
  static readonly styles = [
    ...LabeledElement.styles,
    css`
      :host {
        display: flex;
        flex-direction: column;
        -webkit-user-select: text;
        -ms-user-select: text;
        -moz-user-select: text;
        user-select: text;
      }
      :host([wrap-label]) {
        flex-direction: row;
        flex-wrap: wrap;
      }
      .content {
        display: flex;
        flex-wrap: wrap;
        row-gap: 2px;
        column-gap: 2px;
        font-family: var(--mainSerif), serif;
        line-height: var(--lineHeightDefault);
      }
      :host([system-content]) .content {
        font-family: var(--mainSans), sans-serif;
      }
      .item {
        display: flex;
      }
      .icon {
        position: relative;
        top: 1px;
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }
      .icon.spinner {
        display: inline-block;
      }
      .icon.spinner:after {
        content: '';
        display: block;
        box-sizing: border-box;
        width: 16px;
        height: 16px;
        margin: 1px 2px;
        border-radius: 50%;
        border-width: 3px;
        border-style: solid;
        border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.2);
        animation: rotate 1.2s linear infinite;
      }
      .icon.spinner.noAnimation:after {
        animation: none;
      }
      .icon.check {
        background: url(/images/check-mini-blue.svg) 50% -3px no-repeat;
        background-size: 24px 24px;
      }
      .icon.x {
        background: url(/images/x-fat-orange.svg) 50% -2px no-repeat;
        background-size: 24px 24px;
      }
      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      .text {
        margin-right: 6px;
      }
    `,
  ];

  @property({ type: Array })
  items: TextWithIcon[] = [];
  @property({ type: Boolean, attribute: 'wrap-label', reflect: true })
  wrapLabel = false;
  @property({ type: Boolean, attribute: 'no-animation', reflect: true })
  noAnimation = false;

  renderContent() {
    return html`
      <div class="content">
        ${this.items.map(
          (item) =>
            html` <div class="item">
              <div
                class="icon${classMap({
                  spinner: item.icon === 'spinner',
                  check: item.icon === 'check',
                  x: item.icon === 'x',
                  noAnimation: this.noAnimation,
                })}"
              ></div>
              <div class="text">${item.text}</div>
            </div>`,
        )}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-view-text-with-icons': DViewTextWithIcons;
  }
}
